import { render } from "./CoffersSilver.vue?vue&type=template&id=0a42ec12&scoped=true"
import script from "./CoffersSilver.vue?vue&type=script&lang=js"
export * from "./CoffersSilver.vue?vue&type=script&lang=js"

import "./CoffersSilver.vue?vue&type=style&index=0&id=0a42ec12&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a42ec12"

export default script